<div class="row" *ngIf="loading">
  <div class="loader">Loading...</div>
</div>

<div class="row mb-3" *ngIf="loaded">

  <div class="col text-right align-self-center">
    <button class="btn btn-default mr-2" (click)="back()">Back</button>
    <button class="btn btn-primary" (click)="save()" *ngIf="saveNew == true">Save</button>
    <button class="btn btn-primary" (click)="update()"  *ngIf="saveNew == false">Update</button>
  </div>
</div>

<div class="card" *ngIf="loaded">
  <div class="card-header lead font-weight-bold">
    Offer Advertiser Detail
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <small><i class="text-danger">* indicates mandatory field</i></small>
      </div>
      <div class="col-12 row">
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Advertiser:</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="advertiser.advertiser" class="form-control" placeholder="Advertiser" [readonly]="saveNew == false" />
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Offer ID:</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="advertiser.offerId" class="form-control" placeholder="Offer ID" [readonly]="saveNew == false" />
        </dd>
        <dt class="col-2 text-right align-self-center"> Description:</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="advertiser.description" class="form-control" placeholder="Description" />
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Slice:</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="advertiser.slice" class="form-control" placeholder="Slice Pattern" />
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Timezone:</dt>
        <dd class="col-4">
          <select class="form-control" placeholder="Select" [(ngModel)]="advertiser.timezone">
            <option *ngFor="let timezone of timezones" [value]="timezone">{{timezone}}</option>
          </select>
        </dd>

        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Min :</dt>
        <dd class="col-4">
          <input type="number" [(ngModel)]="advertiser.min" class="form-control" placeholder="Min" min="0" />
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Max :</dt>
        <dd class="col-4">
          <input type="number" [(ngModel)]="advertiser.max" class="form-control" placeholder="Max" min="0" />
        </dd>
        <dt class="col-2 text-right align-self-center"><span class="text-danger">* </span> Rate :</dt>
        <dd class="col-4">
          <input type="number" [(ngModel)]="advertiser.rate" class="form-control" placeholder="Rate" min="0" max="100" />
        </dd>
        <dt class="col-2 text-right align-self-center">Full URL :</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="advertiser.url" class="form-control" placeholder="URL" />
        </dd>
        <dt class="col-2 text-right align-self-center">Customized URL :</dt>
        <dd class="col-4">
          <input type="text" [(ngModel)]="advertiser.customizedUrl" class="form-control" placeholder="Customized URL" />
        </dd>
      </div>
      <div class="col-12">
        <ol type="A">
          <li><span class="font-weight-bold text-danger font-italic">Advertiser:</span>only supports 0-9A-Za-z_</li>
          <li><span class="font-weight-bold text-danger font-italic">Offer ID:</span>only supports 0-9A-Za-z_</li>
          <li><span class="font-weight-bold text-danger font-italic">Max:</span> there is no limitation when it's equal to 0; it will not post-back to client when it's little than 0</li>
          <li><span class="font-weight-bold text-danger font-italic">Rate:</span>It will not post-back to client when it's little than equal 0</li>
          <li><span class="font-weight-bold text-danger font-italic">Customized URL:</span>The priority of Customized-URL is greater than Full-URL</li>
        </ol>
      </div>
    </div>
  </div>
</div>
